import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

export default function PostBatchSubmitDialog(props) {
	const handleClose = () => {
		props.setOpen(false);
	};

	const resultObj = props.batchSubmitResponse;
	const failedUpdates = Array.isArray(resultObj?.failed_updates) ? resultObj.failed_updates : [];
	const classScopedFailures = failedUpdates.filter((failure) => failure?.classid);
	const genericFailures = failedUpdates.filter((failure) => !failure?.classid);
	const groupedClassFailures = Object.values(
		classScopedFailures.reduce((accumulator, failure) => {
			const key = `${failure.classid}-${failure.ctitle || ""}`;
			if (!accumulator[key]) {
				accumulator[key] = {
					classid: failure.classid,
					ctitle: failure.ctitle || "",
					count: 0,
					instructors: [],
				};
			}

			accumulator[key].count += 1;

			if (failure.instructor_name) {
				const roleSuffix = failure.class_role ? ` (${failure.class_role})` : "";
				accumulator[key].instructors.push(`${failure.instructor_name}${roleSuffix}`);
			}

			return accumulator;
		}, {}),
	);
	const hasFailures = failedUpdates.length > 0;
	const isPartialSuccess = resultObj?.successful_updates > 0 && hasFailures;

	return (
		<div>
			<Dialog open={props.open} onClose={handleClose} maxWidth="xl" sx={{ padding: "10px" }}>
				<h1 className="text-center text-2xl p-4">
					{isPartialSuccess ? (
						<p className="text-amber-700">Submission Completed with Warnings</p>
					) : hasFailures ? (
						<p className="text-red-600">Error with Submission</p>
					) : (
						"Submission Completed"
					)}
				</h1>

				<DialogContent sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
					<p className="text-center text-lg p-2 border-2 rounded-md border-green-300 bg-green-100">
						{resultObj?.successful_updates > 0
							? `${resultObj?.successful_updates} Courses Submitted`
							: "0 Courses Submitted"}
					</p>
					{groupedClassFailures.length > 0 && (
						<div className="text-center text-lg p-2 border-2 rounded-md border-amber-300 bg-amber-100">
							<p>
								{classScopedFailures.length} instructor assignment issue
								{classScopedFailures.length === 1 ? "" : "s"} across {groupedClassFailures.length}{" "}
								course
								{groupedClassFailures.length === 1 ? "" : "s"}:
							</p>
							<div className="mt-2 flex flex-col gap-2 text-sm">
								{groupedClassFailures.map((failedCourse) => (
									<div key={`${failedCourse.classid}-${failedCourse.ctitle}`}>
										<div>
											{failedCourse.classid} - {failedCourse.ctitle}
											{failedCourse.count > 1 ? ` (${failedCourse.count} issues)` : ""}
										</div>
										{failedCourse.instructors.length > 0 && (
											<div className="text-xs text-gray-700">
												Affected instructors: {failedCourse.instructors.join(", ")}
											</div>
										)}
									</div>
								))}
							</div>
						</div>
					)}
					{genericFailures.length > 0 && (
						<div className="text-center text-lg p-2 border-2 rounded-md border-red-300 bg-red-100">
							<p>Additional submission errors:</p>
							{genericFailures.map((failed, index) => (
								<div key={`${failed.error || "error"}-${index}`} className="text-sm">
									{failed.error || "Unknown error"}
								</div>
							))}
						</div>
					)}
					{hasFailures && (
						<div className="text-center text-lg p-2 ">
							<p>
								Some issues may be limited to instructor assignments rather than the course
								submission itself. Please review the affected courses before retrying.
							</p>
						</div>
					)}
				</DialogContent>

				<DialogActions>
					<Button onClick={handleClose} variant="contained">
						OK
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
